import React from 'react';
import './loader.scss';
import { Spinner } from 'reactstrap';

const Loader = () => (
  <div className="fallback-spinner position-fixed flex justify-center w-full">
    <div className="loading">
      <Spinner color="primary" />
    </div>
  </div>
);
export default Loader;
